module.exports = __webpack_public_path__ + "static/media/photo285.3d4794d3.jpg";